import { gql } from "@apollo/client";

const SAVE_PARAMETROS_CONTROL_CLINICO_AP = gql`
    mutation saveVisitaParametrosControlClinicoAP($input: AddVisitaParametrosControlClinicoInput!, $idTeleEnfermeria: Int!){
        saveVisitaParametrosControlClinicoAP(input: $input, idTeleEnfermeria: $idTeleEnfermeria) {
            idParametrosControlClinico
        }
    }
`;

export default SAVE_PARAMETROS_CONTROL_CLINICO_AP;

export const adaptAddVisitaParametrosControlClinicoInput = (data) => ({
  idTeleEnfermeria: data?.idTeleEnfermeriaAP,
  input: {
    idParametrosControlClinico: data?.idParametrosControlClinico,
    comoSintioDias: data?.comoSeSintio,
    modifAnimoActividad: data?.modificacionesEstado,
    sienteDolor: !!data?.sienteDolor,
    tuvoFiebre: !!data?.tuvoFiebre,
    presion: data?.comoEstaPresion,
    situacionClinicaAvisar: data?.situacionClinica,
    comoSienteAbdomen: data?.comoSienteAbdomen,
    nauseas: !!data?.nauseas,
    vomito: !!data?.vomito,
    diarrea: !!data?.diarrea,
    constipacion: !!data?.constipacion,
    controlGlucemia: data?.controlGlucemia,
    llamadaMedicoMotivo: data?.llamadaMedicoMotivo,
    dolorDescripcion: data?.dolorDescripcion
  }
});